import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CustomModal } from '../../../shared/services/ziro-modal.service';
import { MigrationsRingCentralPollingService } from '../../services/ring-central/migrations-ring-central-polling.service';
import { Subscription } from 'rxjs';
import { RingCentralExportStatus } from '../../../shared/models/generated/ziroModels';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonSizes, ButtonStyles, ButtonTypes, ZiroButtonComponent } from '../../../button/button.component';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../shared/pipes/pipes.module';

export interface RingCentralPollingModalProperties {
  tenantId: string;
  exportId: string;
}

@Component({
  selector: 'ziro-ring-central-polling-modal',
  templateUrl: 'migrations-ring-central-polling-modal.component.html',
  imports: [ZiroButtonComponent, TranslateModule, PipesModule],
  providers: [MigrationsRingCentralPollingService],
  styleUrls: ['migrations-ring-central-polling-modal.component.scss'],
})
export class MigrationsRingCentralPollingModalComponent
  implements CustomModal<RingCentralPollingModalProperties>, OnInit, OnDestroy
{
  private _migrationsRingCentralPollingService = inject(MigrationsRingCentralPollingService);
  private _activeModal = inject(NgbActiveModal);

  modalProperties: RingCentralPollingModalProperties;
  ButtonTypes = ButtonTypes;

  private _subscription = new Subscription();

  ngOnInit(): void {
    const sub = this._migrationsRingCentralPollingService.state$.subscribe((state) => {
      if (state.status === RingCentralExportStatus.COMPLETED) {
        this._activeModal.close(RingCentralExportStatus.COMPLETED);
      } else if (state.status === RingCentralExportStatus.ERROR) {
        this._activeModal.close(RingCentralExportStatus.ERROR);
        throw new Error(state.statusMessage);
      }
    });
    this._subscription.add(sub);

    this._migrationsRingCentralPollingService.setBaseUrl(this.modalProperties.tenantId, this.modalProperties.exportId);
    this._migrationsRingCentralPollingService.startPolling();
  }

  ngOnDestroy(): void {
    this._migrationsRingCentralPollingService.stopPolling();
    this._subscription.unsubscribe();
  }

  closeModal(): void {
    this._activeModal.close(RingCentralExportStatus.CREATING);
  }

  protected readonly buttonSizes = ButtonSizes;
  protected readonly buttonStyles = ButtonStyles;
  protected readonly ziroIcons = ZiroIcons;
}
